import { watch } from '@vue/composition-api';
import { useWorkFlow } from './useWorkFlow';

/**
 * Composable that handles the initialization of the viewport.
 *
 * @internal
 */
export function useOnInitHandler() {
  const vfInstance = useWorkFlow();

  watch(
    () => vfInstance.viewportHelper.value.viewportInitialized,
    isInitialized => {
      if (isInitialized) {
        setTimeout(() => {
          vfInstance.emits.init(vfInstance);
          // vfInstance.emits.paneReady(vfInstance);
        }, 1);
      }
    }
  );
}
